import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import VehicleImage from '../../../components/VehicleImage/VehicleImage';
import PricePanels from '../../../components/EVJumbotron/PricePanels/PricePanels';
import { FormatAsDollars, FormatCarName } from '../../../utils/Helpers/Format';
import { FormattedMessage } from 'react-intl';
import UsedVehiclePanels from '../../../components/EVJumbotron/UsedVehiclePanels/UsedVehiclePanels';
import UserPrefsContext from '../../../context/UserPrefs/UserPrefsContext';

import vector from '../../../client_customizations/assets/images/icons/vector.svg';
import SmoothScroll from '../../../utils/Helpers/SmoothScroll';
import CarDetailsTable from '../../../components/EVJumbotron/CarDetailsTable/CarDetailsTable';

import './EVJumbotron.scss';

const EVJumbotron = ({ car, paymentDetails, cars, setUsedEv, backTo }) => {
  const userPrefs = React.useContext(UserPrefsContext);

  if (!car) return null;
  const mobile = window.innerWidth < 720;

  //Error Checking code to ensure that pictures have both a thumbnail and full version sutible for display
  // It will remove any null value
  let imagesSrc =
    car && car['images']
      ? car.images.map((n) =>
          n.url_thumbnail == null ? [] : n.url_full == null ? [] : [n]
        )
      : [];

  //Flatten evImgs into a single array
  const images = [].concat.apply([], imagesSrc);
  let carImages = images.map((image) => {
    return {
      original: image.url_full,
      thumbnail: image.url_thumbnail,
      originalAlt: image.alt,
      thumbnailAlt: image.title,
      legalInfo: image.legal_info,
    };
  });
  carImages.shift();

  const handleClick = (car) => {
    userPrefs.set({
      vehicleHandleCompareFilter: car.handle,
    });
  };

  return (
    <>
      <section className="container-fluid" id="ev-jumbotron-title">
        <div className="container evContainer">
          <div className="row">
            <div className="col">
              <Link
                className="backButton"
                to={{
                  pathname: backTo ?? '/vehicles',
                  state: { fromVehicleDetail: true },
                }}
              >
                <img src={vector} alt="back-button"></img>
                <FormattedMessage
                  id="ev.carDetails.view.back"
                  defaultMessage="All vehicles"
                  description="All vehicles"
                />
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-7 col-lg-8">
              <div className="vehicle-title-container">
                <h1 className="car-title">
                  {setUsedEv ? (
                    <FormattedMessage
                      id="ev.usedCarTitle"
                      defaultMessage="Used {car}"
                      description="Used Car Title"
                      values={{
                        car: FormatCarName(car),
                      }}
                    />
                  ) : (
                    FormatCarName(car)
                  )}
                </h1>
                {setUsedEv ? null : (
                  <h2 className="car-subtitle">
                    <FormattedMessage
                      id="ev.carDetails.view.subtitle"
                      defaultMessage="MSRP - {msrp}"
                      description="msrp"
                      values={{
                        msrp: FormatAsDollars(car.msrp),
                      }}
                    />
                  </h2>
                )}
              </div>
              <VehicleImage vehicle={car} image={images[0]} size="full" />
            </div>
            <div className="col-sm-12 col-md-5 col-lg-4">
              <PricePanels car={car} paymentDetails={paymentDetails} />
              <UsedVehiclePanels cars={cars} car={car} setUsedEv={setUsedEv} />
              <br />
              {setUsedEv ? (
                <>
                  <div className="containerPaymentButtons">
                    <Link to={{ pathname: '/incentives', state: { car } }}>
                      <button className="btn btn-smud btn-100">
                        <FormattedMessage
                          id="ev.jumbotron.seeIncentives"
                          defaultMessage="See Incentives"
                          description="see incentives"
                        />
                      </button>
                    </Link>
                    <button
                      className="btn btn-smud btn-100"
                      onClick={(_) => SmoothScroll('CostOfOwnership')}
                    >
                      <FormattedMessage
                        id="ev.jumbotron.totalCost"
                        defaultMessage="See Total Cost"
                        description="total cost"
                      />
                    </button>
                  </div>
                </>
              ) : (
                <div className="containerPaymentButtons">
                  <Link to={{ pathname: '/incentives', state: { car } }}>
                    <button className="btn btn-smud btn-100">
                      <FormattedMessage
                        id="ev.jumbotron.maximizeIncentives"
                        defaultMessage="Maximize incentives"
                        description="maximize incentives"
                      />
                    </button>
                  </Link>
                  <button
                    className="btn btn-smud btn-100"
                    onClick={(_) => SmoothScroll('CostOfOwnership')}
                  >
                    <FormattedMessage
                      id="ev.jumbotron.totalCost"
                      defaultMessage="See total cost of ownership"
                      description="total cost"
                    />
                  </button>
                  <Link to="/compare-vehicles" onClick={() => handleClick(car)}>
                    <button className="btn btn-smud btn-100">
                      <FormattedMessage
                        id="ev.jumbotron.compare"
                        defaultMessage="Compare to other vehicles"
                        description="Compare"
                      />
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="carDetailContainer">
        <div className="container">
          <CarDetailsTable car={car} mobile={mobile} />
        </div>
      </section>
    </>
  );
};

export default EVJumbotron;

EVJumbotron.propTypes = {
  car: PropTypes.object,
  paymentDetails: PropTypes.object,
};
